import { render, staticRenderFns } from "./MessageTranslateDialog.vue?vue&type=template&id=f6804034&scoped=true"
import script from "./MessageTranslateDialog.vue?vue&type=script&lang=js"
export * from "./MessageTranslateDialog.vue?vue&type=script&lang=js"
import style0 from "./MessageTranslateDialog.vue?vue&type=style&index=0&id=f6804034&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6804034",
  null
  
)

export default component.exports